import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { CheckoutCustomerDetails } from '../../models/checkout-customer/checkout-customer-details.interface';

const { telephoneDetails, ...customerDetails } = mockCustomerDetails;

export const mockCheckoutCustomerDetails: CheckoutCustomerDetails = {
  ...customerDetails,
  telephone: telephoneDetails,
};
